import { useDispatch } from 'react-redux'

export const SettingsRadioButton = ({
  property,
  dynamicChoices = () => false,
  choices = [],
  data,
  update,
}) => {
  const dispatch = useDispatch()
  const { [property]: entryValue } = data
  const options = dynamicChoices(data) || choices

  const handleChange = e => {
    const updatedValue = e.target.value
    const { additionalProperties = {} } =
      options.find(({ value }) => String(value) === updatedValue) || {}
    dispatch(
      update({
        [property]: updatedValue,
        ...additionalProperties,
      })
    )
  }

  return (
    <div>
      {options.map(option => (
        <label key={option.value} style={{ marginRight: 8 }}>
          <input
            type="radio"
            name={property}
            value={option.value}
            checked={String(entryValue) === String(option.value)}
            onChange={handleChange}
          />
          {option.label ?? option.value}
        </label>
      ))}
    </div>
  )
}
